import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  margin-bottom: 2rem;
  margin-top: 1rem;

  li {
    margin-bottom: 1rem;
  }

  span {
    font-weight: 700;
    margin-right: 1rem;
  }
`;
